export class RunComment {
    userComment: string;
    commentDate: Date;
    puid: string;
    runId: string;
}